import gsap from "gsap";
import { clamp, damp } from "../utils/math";

export class HoverField {
  constructor(stage, field) {
    this.stage = stage;
    this.field = field;
    this.enabled = false;
    this.force = 0;
    this.pointer = { x: window.innerWidth * 0.5, y: window.innerHeight * 0.5 };

    window.addEventListener(
      "pointermove",
      (event) => {
        this.pointer.x = event.clientX;
        this.pointer.y = event.clientY;
      },
      { passive: true },
    );
  }

  enable() {
    this.enabled = true;
    gsap.to(this, { force: 1, duration: 1.1, ease: "power1.inOut" });
  }

  update(dt) {
    if (!this.enabled) return;

    const world = this.stage.worldAtZ0(this.pointer.x, this.pointer.y);
    const leanX = clamp(world.x / this.field.radius, -1.35, 1.35) * this.force;
    const leanY = clamp(world.y / this.field.radius, -1.15, 1.15) * this.force;

    this.stage.ring.rotation.y = damp(
      this.stage.ring.rotation.y,
      leanX * 0.12,
      6,
      dt,
    );
    this.stage.ring.rotation.x = damp(
      this.stage.ring.rotation.x,
      -leanY * 0.08,
      6,
      dt,
    );

    const influenceRadius = Math.PI * 0.3 * this.field.radius;
    const ease = gsap.parseEase("sine.inOut");

    this.field.cards.forEach((card) => {
      const base = this.field.ringPos(card.index);
      const dx = base.x - world.x;
      const dy = base.y - world.y;
      const dist = Math.hypot(dx, dy);
      const raw = clamp(1 - dist / influenceRadius, 0, 1);
      const g = ease(raw) * this.force;

      card.hover.extraR = damp(
        card.hover.extraR,
        g * (this.field.radius * 0.22),
        9,
        dt,
      );
      card.hover.rotY = damp(card.hover.rotY, g * Math.PI * 0.92, 9, dt);
      card.hover.z = damp(card.hover.z, g * 0.42, 9, dt);
    });
  }
}
